import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { InactivityLogoutComponent } from './auth/inactivity-logout/inactivity-logout.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { OktaLoginComponent } from './auth/okta-login/okta-login.component';
import { OktaCallbackComponent } from './auth/okta-callback/okta-callback.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MatButtonModule,
    InactivityLogoutComponent,
    LogoutComponent,
    OktaCallbackComponent,
    OktaLoginComponent,
  ],
  exports: [
    InactivityLogoutComponent,
    LogoutComponent,
    OktaCallbackComponent,
    OktaLoginComponent,
  ],
})
export class SharedComponentsAuthModule {}
